import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import configs from '../../../../config/config';
import { getCurrentMemberDetails } from '../../../../store/selectors';

const MemberStats = () => {
    const { t } = useTranslation();
    const stats = useSelector(getCurrentMemberDetails);
    const summary = stats.summary || {};
    return (
        <div className="winnings">
            <div className="winItem">
                <p>{stats.overallWL || 0}</p>
                <p>{t('overallWL')}</p>
            </div>
            <div className="winItem">
                <p>{summary.poker ? summary.poker.wl : 0}</p>
                <p>{t('pokerWL')}</p>
            </div>
            <div className="winItem">
                <p>{summary.poker ? summary.poker.fee : 0}</p>
                <p>{t('pokerFees')}</p>
            </div>
            <div className="winItem">
                <p>{summary.casino ? summary.casino.wl : 0}</p>
                <p>{t('casinoWL')}</p>
            </div>
            <div className="winItem">
                <p>{summary.liveCasino ? summary.liveCasino.wl : 0}</p>
                <p>{t('liveCasinoWL')}</p>
            </div>
            <div className="winItem">
                <p>{summary.sports ? summary.sports.wl : 0}</p>
                <p>{t('sportsWL')}</p>
            </div>
        </div>
    );
}
export default MemberStats;